module.exports = __webpack_public_path__ + "img/chevron-left.37077add.svg";